import { useState, useEffect } from "react";
// import { notifyError } from "../../../../../assets/toastService";
import { Product } from "src/shared/services/interfacev2";
import { getProduct } from "src/shared/services/servicesv2";

export const useProducts = (showDeleted: boolean, page: number, rowsPerPage: number, search: string, categoryFilter: string) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const fetchProducts = async () => {
    setLoading(true);
    setProducts([]);

    try {
      const response = await getProduct(showDeleted, page + 1, rowsPerPage, debouncedSearch.trim() || undefined, categoryFilter !== "all" ? categoryFilter : undefined);
      // let apiUrl = `/app/pos/v2/product?include_deleted=${showDeleted}&pageNumber=${page + 1}&pageSize=${rowsPerPage}`;

      // if (search) {
      //   apiUrl += `&searchBy=${search}`;
      // }

      // if (categoryFilter && categoryFilter !== "all") {
      //   apiUrl += `&category_id=${categoryFilter}`;
      // }

      // const response = await api.get(apiUrl);
      const productsData = response.data.results.map((product: any) => ({
        ...product,
        staff_list: Array.isArray(product.staff_list)
          ? product.staff_list.map((staff: any) => ({
              name: typeof staff === "string" ? staff : staff.name || staff.staff_name || "",
            }))
          : [],
      }));

      setProducts(productsData);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      console.error("Error fetching products:", error);
      // notifyError("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

 // ✅ Trigger fetch ONLY after debounce
  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDeleted, page, rowsPerPage, debouncedSearch, categoryFilter]);

  return { products, totalRecords, loading, refetchProducts: fetchProducts };
};
